exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".logout-icon.ant-btn{display:inline-flex;align-items:center;gap:1rem;font-weight:600;font-size:1.4rem;line-height:1.6rem}[dir] .logout-icon.ant-btn{border:0 none;background-color:inherit;box-shadow:none}[dir] .logout-icon:disabled{background-color:#fff}", ""]);

